import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'
import ReactHtmlParser from 'react-html-parser'

import I18n from 'lib/i18n'

import SubscribeForm from '~/scenes/footer/subscribe-form'

import iconsMap from '~/scenes/footer/icons-map'

const FollowUs = ({ socialMediaIcons, subscribeUrl }) => {
  return (
    <div className='four columns'>
      <div className='clearfix'>
        <h1 className='header'>{I18n.t('layouts.footer.follow')} </h1>
        {socialMediaIcons.map((socialMediaIconsPerColumn, index) => (
          <ul className='social half-menu inner' key={index}>
            {index === 0 && (
              <li className='hide-when-big'>
                <p className='apprentus-newsletter-paragraph-mobile'>
                  {ReactHtmlParser(I18n.t('layouts.footer.newsletter_info'))}
                </p>
                <br />
                <SubscribeForm subscribeUrl={subscribeUrl} />
              </li>
            )}
            {socialMediaIconsPerColumn.map(({ link, icon, name }, index) => (
              <li key={index}>
                <a href={link}>
                  <img
                    data-src={iconsMap[icon]}
                    alt={name}
                    height='31'
                    width='30'
                    className={`imgspan lazyload ${icon}`}
                  />
                  {name}
                </a>
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  )
}

FollowUs.propTypes = {
  socialMediaIcons: PropTypes.array,
  subscribeUrl: PropTypes.string
}

export default FollowUs
